import { render, staticRenderFns } from "./fccTestesCandidato.vue?vue&type=template&id=72657643"
import script from "./fccTestesCandidato.vue?vue&type=script&lang=js"
export * from "./fccTestesCandidato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports